<template>
  <date-range-picker
    :clearable="clearable"
    v-model="currentValue"
    :disabled="disabled"
    :max-date="maxDate"
    :controlContainerClass="{ disabled: disabled }"
    :single-date-picker="isRange ? false : true"
    :opens="direction || 'right'"
    :ranges="ranges || false"
    :placeholder="$t(placeholder)"
    :time-picker="timePicker || false"
    :time-picker-increment="timePickerIncrement || 1"
    :show-dropdowns="showDropDowns || true"
    :auto-apply="isRange"
    :locale-data="
      isViLanguage
        ? {
            format: 'mm/dd/YYYY HH:mm',
            daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
            monthNames: [
              'Tháng 1',
              'Tháng 2',
              'Tháng 3',
              'Tháng 4',
              'Tháng 5',
              'Tháng 6',
              'Tháng 7',
              'Tháng 8',
              'Tháng 9',
              'Tháng 10',
              'Tháng 11',
              'Tháng 12',
            ],
            firstDay: 0,
          }
        : undefined
    "
  />
</template>
<script>
import DateRangePicker from "@/@core/components/ez-daterange-picker/components/DateRangePicker.vue";

import { Fragment } from "vue-fragment";

export default {
  name: "WidgetDateTime",
  methods: {},
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    maxDate: [String, Date,Object],
    value: [String, Object],
    labelCols: Number,
    isRange: Boolean,
    disabled: [Boolean, String, Number],
    label: String,
    direction: String,
    ranges: Boolean,
    timePickerIncrement: Number,
    timePicker: Boolean,
    showDropDowns: Boolean,
    placeholder: String,
    autoApply: Boolean,
  },
  data: () => ({
    currentValue: "",
  }),
  watch: {
    value: {
      handler: function (v) {
        this.currentValue = v;
      },
      deep: true,
    },
    currentValue(val) {
      this.$emit("input", val);
    },
  },
  mounted() {
    this.currentValue = this.value;
  },
  computed: {},
  components: {
    Fragment,

    DateRangePicker,
  },
};
</script>
